import React from "react";
import TierDialog from "../../pages/Admin/TierManagement/TierDialog";
import SectorDialog from "../../pages/Admin/SectorManagement/SectorDialog";
import UserDetailDialog from "../../pages/Admin/UserManagement/UserDetailDialog";
import ClientDetailDialog from "../../pages/Admin/ClientManagement/ClientDetailDialog";
import CategoryDialog from "../../pages/Admin/CategoryManagement/CategoryDialog";
import SubCategoryDialog from "../../pages/Admin/SubCategoryManagement/SubCategoryDialog";
import RatingSpreadDialog from "../../pages/Admin/RatingSpreadManagement/RatingSpreadDialog";
import AnalystAssignmentDialog from "../../pages/Admin/AnalystAssignmentManagement/AnalystAssignmentDialog";

export const CommonDialog = ({ dialogType, open, onClose, rowData }) => {
    return (
        <div>
            {(() => {
                switch (dialogType) {
                    case "tier":
                        return (
                            <TierDialog
                                open={open}
                                onClose={onClose}
                                rowData={rowData}
                                isEdit={true}
                                title={"Edit Tier"}
                                ctaText={"SAVE"}
                            />
                        );
                    case "sector":
                        return (
                            <SectorDialog
                                open={open}
                                onClose={onClose}
                                rowData={rowData}
                                isEdit={true}
                                title={"Edit Sector"}
                                ctaText={"SAVE"}
                            />
                        );
                    case "user":
                        return (
                            <UserDetailDialog
                                open={open}
                                onClose={onClose}
                                rowData={rowData}
                                isEdit={true}
                                title={"Edit User Details"}
                                ctaText={"SAVE"}
                            />
                        );
                    case "client":
                        return (
                            <ClientDetailDialog
                                open={open}
                                onClose={onClose}
                                rowData={rowData}
                                isEdit={true}
                                title={"Edit Client Details"}
                                ctaText={"SAVE"}
                            />
                        );
                    case "category":
                        return (
                            <CategoryDialog
                                open={open}
                                onClose={onClose}
                                rowData={rowData}
                                isEdit={true}
                                title={"Edit Category"}
                                ctaText={"SAVE"}
                            />
                        );
                    case "subcategory":
                        return (
                            <SubCategoryDialog
                                open={open}
                                onClose={onClose}
                                rowData={rowData}
                                isEdit={true}
                                title={"Edit Sub Category"}
                                ctaText={"SAVE"}
                            />
                        );
                    case "ratingspread":
                        return (
                            <RatingSpreadDialog
                                open={open}
                                onClose={onClose}
                                rowData={rowData}
                                isEdit={true}
                                title={"Edit Rating Spread"}
                                ctaText={"SAVE"}
                            />
                        );
                    case "analystAssignment":
                        return (
                            <AnalystAssignmentDialog
                                open={open}
                                onClose={onClose}
                                rowData={rowData}
                                isEdit={true}
                                title={"Edit Analyst Assignment"}
                                ctaText={"SAVE"}
                            />
                        );
                    default:
                        return null;
                }
            })()}
        </div>
    );
};
